import { ReactNode } from 'react';
import { twMerge } from 'tailwind-merge';

import { SharePlanType } from '../../types/pool-plans.types';

export const SummaryItem = ({
  title,
  value,
  className,
  titleAdditionalNote,
  id,
  planType,
}: {
  className?: string;
  title: ReactNode | string | undefined;
  titleAdditionalNote?: ReactNode | string;
  value:
    | ((id: string, fields: { planType: SharePlanType }) => ReactNode)
    | number
    | ReactNode
    | string;
} & Optional<{ id: string; planType: SharePlanType }>) => (
  <div
    className={twMerge(
      'flex items-center justify-between gap-2 text-nowrap py-3 pl-3 pr-4 text-sm font-[450] text-gray-700',
      className,
    )}
  >
    <div className="flex flex-col justify-center">
      <span className="text-gray-500">{title}</span>
      <span className="text-label-sm font-medium text-gray-500">{titleAdditionalNote}</span>
    </div>
    <span className="min-w-0 truncate text-right text-gray-700 [&_.flex]:items-end">
      {typeof value === 'function' ? planType && value(id || '', { planType }) : value}
    </span>
  </div>
);
